import React, { Component } from "react";
import styled from 'styled-components';

import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  ResponsiveContainer
} from 'recharts';

import { ContentContainerWithBackground } from '../components/ui';
import polarAngleAxis from './polar-angle-axis';

const ChartTitle = styled.h2`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 12px;
`;

const ChartLegendsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

const ChartLegend = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 1px;
  margin-right: 20px;

  &:before {
    display: block;
    content: '';
    width: 20px;
    height: 20px;
    margin-right: 14px;
  }

  &${p => p.isFinal && `:before {
    background: #A98DF6;
  }`}}
  
  &${p => p.isSecond && `:before {
    background: #52C5CD;
  }`}}
  
  &${p => p.isInitial && `:before {
    background: #ECA427;
  }`}
`;

class SkillsChart extends Component {
  render() {
    const {
      title,
      data,
      showData
    } = this.props;

    const secondDataLegend = showData.final ? 'Skills (previous)' : 'Skills (As of now)';

    return (
      <ContentContainerWithBackground>
        <ChartTitle>{title}</ChartTitle>
        <ResponsiveContainer width="100%" height={300}>
          <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data} margin={{ bottom: 50 }}>
            <PolarGrid />
            <PolarAngleAxis
              dataKey="question"
              tick={props => polarAngleAxis(props)}
              cx={10}
              cy={10}
            />
            <Radar
              dataKey="initial"
              stroke="#F9C151"
              strokeWidth={2}
              fill="rgba(254, 198, 101, 0.25)"
              cx={10}
              cy={10}
              dot={{ stroke: '#F9C151', strokeWidth: 3, r: 2, strokeDasharray: '' }}
            />
            {
              showData.second &&
              <Radar
                dataKey="second"
                stroke="#55B4BC"
                strokeWidth={2}
                fill="rgba(82, 197, 205, 0.5)"
                cx={10}
                cy={10}
                dot={{ stroke: '#55B4BC', strokeWidth: 3, r: 2, strokeDasharray: '' }}
              />
            }
            {
              showData.final &&
              <Radar
                dataKey="final"
                stroke="#A98DF6"
                strokeWidth={2}
                fill="rgba(169, 141, 246, 0.5)"
                cx={10}
                cy={10}
                dot={{ stroke: '#A98DF6', strokeWidth: 3, r: 2, strokeDasharray: '' }}
              />
            }
            <PolarRadiusAxis
              angle={90}
              orientation="left"
              domain={[0, 5]}
              ticks={[1, 2, 3, 4, 5]}
              tickCount={6}
              style={{
                transform: 'translateY(5px)',
                fill: '#667689'
              }}
            />
          </RadarChart>
        </ResponsiveContainer>
        <ChartLegendsContainer>
          {
            showData.final &&
            <ChartLegend isFinal>Skills (As of now)</ChartLegend>
          }
          {
            showData.second &&
            <ChartLegend isSecond>{secondDataLegend}</ChartLegend>
          }
          <ChartLegend isInitial>Skills (Initial)</ChartLegend>
        </ChartLegendsContainer>
      </ContentContainerWithBackground>
    );
  }
}

export default SkillsChart;


// WEBPACK FOOTER //
// ./src/components/peer-feedback/components/skills-chart.js